var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1665 8.50033C15.1665 12.4585 11.958 15.667 7.99984 15.667C4.04169 15.667 0.83317 12.4585 0.833171 8.50032C0.833171 4.54218 4.0417 1.33366 7.99984 1.33366C11.958 1.33366 15.1665 4.54218 15.1665 8.50033ZM7.99984 14.667C11.4057 14.667 14.1665 11.9062 14.1665 8.50033C14.1665 5.09447 11.4057 2.33366 7.99984 2.33366C4.59398 2.33366 1.83317 5.09447 1.83317 8.50032C1.83317 11.9062 4.59398 14.667 7.99984 14.667ZM7.65683 11.871C7.4525 11.6852 7.43745 11.369 7.6232 11.1647L7.62987 11.1573C7.81562 10.953 8.13185 10.9379 8.33618 11.1237C8.5405 11.3094 8.55556 11.6257 8.36981 11.83L8.36314 11.8373C8.17738 12.0417 7.86116 12.0567 7.65683 11.871ZM7.99984 9.33366C7.7237 9.33366 7.49984 9.1098 7.49984 8.83366L7.49984 5.50032C7.49984 5.22418 7.7237 5.00032 7.99984 5.00032C8.27598 5.00032 8.49984 5.22418 8.49984 5.50032L8.49984 8.83366C8.49984 9.1098 8.27598 9.33366 7.99984 9.33366Z",
    fill: "#1F2937"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.938fe268d17c12c58b2d9b3707353bd9.svg";
export { ForwardRef as ReactComponent };